// Main application component
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './pages/Dashboard/Dashboard';
import Expenses from './pages/Expenses/Expenses';
import Webstaurant from './pages/Webstaurant/Webstaurant';
import DcPrices from './pages/DcPrices/DcPrices';
import Files from './pages/Files/Files';
import Login from './pages/Login/Login';
import AppLayout from './components/layout/AppLayout';
import ProtectedRoute from './components/auth/ProtectedRoute';
import FileManagementRoute from './components/auth/FileManagementRoute';

const App: React.FC = () => {
  return (
    <Routes>
      {/* Public route - Login */}
      <Route path="/login" element={<Login />} />

      {/* Protected routes with layout */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="expenses" element={<Expenses />} />
        <Route path="webstaurant" element={<Webstaurant />} />
        <Route path="dc-prices" element={<DcPrices />} />
        <Route
          path="files"
          element={
            <FileManagementRoute>
              <Files />
            </FileManagementRoute>
          }
        />
      </Route>

      {/* Catch all - redirect to dashboard */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
};

export default App;
